import React from "react";
import { Button } from "react-bootstrap";

export default function AskIsCard({setAskIsCard, setIsCard}) {

  return (
    <div className="choose-if-card">
        <p>Do you want to pay from the account connected to your card?</p>
        <Button variant="dark" size="lg" block onClick={() => {setIsCard(true); setAskIsCard(false)}} style={{marginRight: 50}}>
            YES
        </Button>
        <Button variant="dark" size="lg" block onClick={() => {setIsCard(false); setAskIsCard(false)}}>
            NO
        </Button>
    </div>
  );
}
